import { render, staticRenderFns } from "./DialogTaoPhieuSuaChua.vue?vue&type=template&id=ba3181a2"
import script from "./DialogTaoPhieuSuaChua.vue?vue&type=script&lang=js"
export * from "./DialogTaoPhieuSuaChua.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports